export const SET_PAGE = "set page";
export const SET_AUTH_USER = "set_auth_user";
export const SET_ALERT = "set_alert";
